// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import * as VueMenu from '@hscmap/vue-menu'
import LanguageConfig from './Core/Language/LanguageConfig'
import { Storage } from './Storage.js'
import './configs.js'

Vue.use(VueMenu)
Vue.config.productionTip = false

Storage.init()

window.LangConfig = new LanguageConfig()
window.vms = {}
window.codeMirrorCssNode = null
window.changeCodeMirrorFont = function (newFont) {
    if (window.codeMirrorCssNode === null) {
        window.codeMirrorCssNode = document.createElement('style')
        window.codeMirrorCssNode.type = 'text/css'
        document.getElementsByTagName('head')[0].appendChild(window.codeMirrorCssNode)
    }

    var newStyle = '.CodeMirror * { font-family: "' + newFont + '" !important; }'

    if (window.codeMirrorCssNode.styleSheet) {
        window.codeMirrorCssNode.styleSheet.cssText = newStyle
    } else {
        window.codeMirrorCssNode.appendChild(document.createTextNode(newStyle))
    }
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js